module.exports = __webpack_public_path__ + "static/img/丽水市中小微企业服务券@3x.959e3499.png";